import axios from 'axios';
import { MediaFileResponseDTO } from './types';
import { getUploadUrlByProductType } from './helper';
import { ProductType } from '@/models/ad';

type UploadFile = {
  file: File;
  beforeCallback?: () => void;
  afterCallback?: () => void;
  token: string | null;
  productType: ProductType;
};

export const uploadFile = async ({
  file,
  beforeCallback,
  afterCallback,
  token,
  productType,
}: UploadFile) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    if (beforeCallback) beforeCallback();
    // TODO: need to be fixed and token should be used directly by axios/fetch

    const url = getUploadUrlByProductType(
      `${import.meta.env.VITE_API_HOST}/v1/upload`,
      productType
    );

    const response = await axios.post<MediaFileResponseDTO>(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: `Bearer ${token}`,
      },
    });

    if (afterCallback) afterCallback();

    return response.data;
  } catch (e) {
    // TODO: Fix error
    console.log('error', e);
  }
};
